import { User } from "oidc-client-ts";
import { MTS_ENV } from "./setupEnv";

export function getAuthentifiedUser() {
  const oidcStorage =
    localStorage.getItem(`oidc.user:${MTS_ENV.OIDC_AUTHORITY}:${MTS_ENV.OIDC_CLIENT_ID}`) ??
    localStorage.getItem("oidc.user:metroscope:frontend");
  if (!oidcStorage) return null;

  return User.fromStorageString(oidcStorage);
}
